import { signer } from "theme/colors";
import {
  amber,
  slate,
  CARD,
  FOOTER,
} from "screens/SignRequest/ParticipantScreen/components/SignerStatusCard.tokens";

/**
 * Screen tokens for the public `/link-expired` landing (dead SMS short link).
 * Reuses the shared card chrome/typography (`CARD`) and the amber/slate
 * status gradients already established for the guest signer status cards —
 * see `SignerStatusCard.tokens.ts` — rather than declaring new hex here.
 *
 * Kept as a temporary, screen-scoped file per UI_IMPLEMENTATION_RULES.
 */

export { CARD, FOOTER };

/** `r=expired` — amber, same tone as a request's own "expired" status card. */
export const EXPIRED_VISUAL = amber;
/** `r=notfound` — neutral slate; never alarming, since a typo is as likely as an expiry. */
export const NOTFOUND_VISUAL = slate;

/**
 * "Ask whoever sent you this document…" block under the body copy. Sits at the
 * same size as the body but separated by its own gap and a hairline, so it
 * reads as the next step rather than more explanation of the problem.
 */
export const CONTACT_ROW = {
  gap: 20, // margin-top under the body copy
  dividerGap: 16, // space between the hairline and the contact line
  divider: signer.border.light,
  dividerWidth: 44,
  fontSize: CARD.bodySize,
  lineHeight: CARD.bodyLineHeight,
  color: CARD.bodyColor,
  maxWidth: CARD.bodyMaxWidth,
  /** The "only the sender can issue a new link" footnote below it. */
  noteGap: 10,
  noteFontSize: "11.5px",
  noteColor: signer.text.faint,
} as const;

export const CODE_ROW = {
  gap: 22, // margin-top under the button/body
  fontSize: "11px",
  color: signer.text.faint,
} as const;
